<template lang="pug">
modal-base.modal-window(
  ref='modalBase',
  :width='width',
  :height='height',
  :clickToClose='clickToClose',
  :styles='modalStyles',
  @closed='closed'
)
  .modal-window__content
    .modal-window__content__header
      .modal-window__header__title.text-xlarge.font-bold {{ title }}
      button-base.modal-window__content__header__close(@click='hide')
        image-base.modal-window__content__header__close__icon(:src='require("@/assets/img/common/icon/close.svg")')
    .modal-window__content__body
      slot
</template>

<script lang="ts">
import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import ModalBase from '@/components/atoms/ModalBase.vue'
import ButtonBase from '@/components/atoms/ButtonBase.vue'
import ImageBase from '@/components/atoms/ImageBase.vue'

const DEFAULT_WIDTH = 550
const DEFAULT_HEIGHT = 550

/**
 * モーダルウインドウ
 */
@Component({
  components: {
    ModalBase,
    ButtonBase,
    ImageBase,
  },
})
export default class ModalWindow extends Vue {
  // モーダル表示幅(px) - デフォルト値以外の場合は指定
  @Prop({ default: DEFAULT_WIDTH })
  width?: number

  // モーダル表示高さ(px) - デフォルト値以外の場合は指定
  @Prop({ default: DEFAULT_HEIGHT })
  height?: number

  // タイトル
  @Prop()
  title!: string

  // 背景クリック時にモーダルを閉じるか否か(ライブラリオプション)
  //   未指定時は閉じる
  @Prop({ default: true })
  clickToClose?: boolean

  // モーダル枠外にはみ出した要素を表示するか
  @Prop({ default: false })
  overflowVisible?: boolean

  // モーダルベースのref定義
  @Ref() modalBase!: ModalBase

  // モーダル表示のスタイルオプション
  private get modalStyles(): { [key: string]: string } {
    return {
      borderRadius: '15px',
      overflow: this.overflowVisible ? 'visible' : 'hidden',
    }
  }

  // モーダルの消去
  public hide() {
    this.modalBase.hide()
  }

  // モーダルの表示
  public show() {
    this.modalBase.show()
  }

  // モーダル消去時のイベントを通知
  //   @closed='function'でモーダル消去時に処理の実行が可能
  private closed() {
    this.$emit('closed')
  }
}
</script>

<style lang="stylus" scoped>
.modal-window
  &__content
    display flex
    padding 20px
    height 100%
    flex-direction column
    align-items flex-start
    gap 12px

    &__header
      display flex
      height 35px
      justify-content space-between
      align-items center
      align-self stretch

      &__title
        display flex

      &__close
        display flex
        align-items center
        justify-content center
        width 30px
        height 30px

        &::before
          position absolute
          content ''
          width 4px
          height 4px
          border-radius 2px
          background-color var(--color-manager-modal-close-button__background)
          transition-duration 0.5s

        &:hover
          &::before
            transform scale(7.5)

        &__icon
          width 20px
          height 20px
</style>
